









































































































































































































































































































































































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import * as s_Interface from '@/interface/store/manageGroups';
import { validateURL } from '@/utils/validate';
import { openSuggestions } from '@/utils/common';

const namespace: string = 'manageGroup';

@Component
export default class ModalItem extends Vue {
  @Prop({ type: Boolean, default: false }) dialogVisible!: boolean;

  @Action('setInventoryItem', { namespace: 'inventory' }) c_setInventoryItem!: any;
  @Action('getVendors', { namespace }) c_getVendors!: any;
  @Action('getManufacturers', { namespace }) c_getManufacturers!: any;
  @Action('getTypes', { namespace }) c_getTypes!: any;
  @Action('getMainLocations', { namespace }) c_getMainLocations!: any;
  @Action('getSubLocations', { namespace: 'manageGroup' }) c_getSubLocations!: any;
  @Action('setVendor', { namespace }) c_setVendor!: any;
  @Action('setManufacturer', { namespace }) c_setManufacturer!: any;
  @Action('setType', { namespace }) c_setType!: any;
  @Action('setMainLocation', { namespace }) c_setMainLocation!: any;
  @Action('setSubLocation', { namespace }) c_setSubLocation!: any;
  @Action('getTypeFields', { namespace }) c_getTypeFields!: any;

  @Getter('getterTypes', { namespace }) c_getterTypes!: Array<s_Interface.TypeData>;
  @Getter('getterVendors', { namespace }) c_getterVendors!: Array<s_Interface.VendorData>;
  @Getter('getterManufacturers', { namespace }) c_getterManufacturers!: Array<
    s_Interface.ManufacturerData
  >;
  @Getter('getterMainLocations', { namespace }) c_getterMainLocations!: Array<
    s_Interface.MainLocationData
  >;
  @Getter('getterTypeFields', { namespace }) c_getterTypeFields!: Array<s_Interface.TypeFieldItem>;
  @Getter('getterSubLocations', { namespace }) c_getterSubLocations!: Array<
    s_Interface.SubLocationData
  >;
  @Getter('getterMembers', { namespace }) c_getterMembers!: Array<s_Interface.Member>;
  @Getter('getterUser', { namespace: 'profile' }) c_getterUser!: any;
  @Getter('getterAuthUserId', { namespace: 'auth' }) c_getterAuthUserId!: string;

  public validateURL: Function = validateURL;
  public propsDialogVisible: boolean = this.dialogVisible;
  public ruleForm: any = {
    ownedBy: null,
    fkVendorId: null,
    fkManufacturerId: null,
    catalogNumber: null,
    name: null,
    price: 0,
    unitSize: null,
    quantity: 0,
    unit: 'units',
    url: null,
    typeName: null,
    fkTypeId: null,
    fkLocationId: null,
    fkLocationSubId: null,
    customFields: [],
    technicalDetails: null,
    expiresOn: null,
    expirationReminder: null,
    lotNumber: null,
    casNumber: null,
    notes: null,
    vendorName: null,
    manufacturerName: null,
  };
  public rules: any = {
    name: [
      { required: true, message: '물품명을 입력해주세요.', trigger: 'blur' },
      { max: 150, message: '물품명은 150자를 넘을 수 없습니다.', trigger: ['blur', 'change'] },
    ],
    vendorName: { required: false, message: '판매처를 입력해주세요.', trigger: ['blur', 'change'] },
    manufacturerName: {
      required: false,
      message: '제조사를 입력해주세요.',
      trigger: ['blur', 'change'],
    },
    catalogNumber: [
      { required: false, message: '카탈로그 번호를 입력해주세요.', trigger: 'blur' },
      {
        max: 100,
        message: '카탈로그 번호는 100자를 넘을 수 없습니다.',
        trigger: ['blur', 'change'],
      },
    ],
    typeName: { required: true, message: '타입명을 입력해주세요.', trigger: ['blur', 'change'] },
    quantity: [
      {
        type: 'number',
        message: '반드시 숫자를 입력해주세요.',
        trigger: ['blur', 'change'],
      },
      {
        pattern: /(^\d{1,9}$)/,
        message: '입력할 수 없는 범위의 숫자입니다.',
        trigger: 'blur',
      },
    ],
    price: [
      {
        type: 'number',
        message: '반드시 숫자를 입력해주세요.',
        trigger: ['blur', 'change'],
      },
      {
        pattern: /(^\d{1,9}$)/,
        message: '입력할 수 없는 범위의 숫자입니다.',
        trigger: 'blur',
      },
    ],
  };
  public unitKind: any = [
    {
      label: 'Unit(s)',
      options: [
        { value: 'bottles', label: 'bottles' },
        { value: 'boxes', label: 'boxes' },
        { value: 'cases', label: 'cases' },
        { value: 'packs', label: 'packs' },
        { value: 'units', label: 'units' },
      ],
    },
    {
      label: 'Mass/Weight',
      options: [
        { value: 'µg', label: 'µg' },
        { value: 'mg', label: 'mg' },
        { value: 'g', label: 'g' },
        { value: 'kg', label: 'kg' },
        { value: 'pmol', label: 'pmol' },
        { value: 'nmol', label: 'nmol' },
        { value: 'µmol', label: 'µmol' },
        { value: 'mmol', label: 'mmol' },
        { value: 'mol', label: 'mol' },
        { value: 'oz', label: 'oz' },
        { value: 'lb', label: 'lb' },
      ],
    },
    {
      label: 'Volume',
      options: [
        { value: 'µL', label: 'µL' },
        { value: 'mL', label: 'mL' },
        { value: 'L', label: 'L' },
        { value: 'fl oz', label: 'fl oz' },
        { value: 'gal', label: 'gal' },
        { value: 'mm', label: 'mm' },
      ],
    },
    {
      label: 'Length',
      options: [
        { value: 'm', label: 'm' },
        { value: 'in', label: 'in' },
        { value: 'ft', label: 'ft' },
        { value: 'yd', label: 'yd' },
      ],
    },
  ];
  public customTypeArray: any = [];
  public subLocationArray: any = [];
  public fileNameArray: Array<string> = [];
  public filePayload: Array<any> = [];
  public expirationReminder: any = [
    { label: '없음', value: 'NEVER' },
    { label: '1주 전', value: 'ONE_WEEK' },
    { label: '2주 전', value: 'TWO_WEEK' },
    { label: '1달 전', value: 'ONE_MONTH' },
  ];
  public staticCustomFieldString: string = '타입 세부정보 추가하기';
  public isShow: boolean = false;
  public initOwner: string = '';
  public vendorName: string = '';
  public manufacturerName: string = '';
  public typeName: string = '';
  public mainLocationName: string = '';
  public subLocationName: string = '';
  public changeVendorInput: boolean = false;
  public changeManufacturerInput: boolean = false;
  public changeTypeInput: boolean = false;
  public changeMainLocationInput: boolean = false;
  public changeSubLocationInput: boolean = false;
  public openSuggestions: Function = openSuggestions;

  get activeMembers() {
    return this.c_getterMembers.filter((member) => member.status == 'ACTIVE');
  }

  get itemWriter() {
    if (this.ruleForm.ownedBy === null || this.ruleForm.ownedBy === '') {
      this.initOwner = this.c_getterUser.fullName;
      this.ruleForm.ownedBy = this.c_getterAuthUserId;
    }
    return this.initOwner;
  }

  async created() {
    const groupId: string = this.$route.params.groupId;

    this.ruleForm.expirationReminder = this.expirationReminder[0].value;

    const defaultType: any = this.c_getterTypes.find((item: any) => item.prefix === 'A');

    if (defaultType !== undefined) {
      this.ruleForm.fkTypeId = defaultType.id;
      this.ruleForm.typeName = defaultType.name;
      this.typeName = this.ruleForm.typeName;
      await this.c_getTypeFields({ groupId, typeId: defaultType.id });
      this.customTypeArray = this.c_getterTypeFields;
      this.ruleForm.customFields = [...this.customTypeArray];
    }
  }

  createFilter(queryString: string) {
    return (link: any) => link.name.indexOf(queryString) === 0;
  }

  @Watch('vendorName')
  onVendorName(c: any, p: any) {
    if (this.vendorName === '') {
      this.ruleForm.fkVendorId = null;
      this.ruleForm.vendorName = null;
    }
  }

  vendorQuerySearch(queryString: string, cb: any) {
    const vendorLinks = this.c_getterVendors;
    const changeVendorInput = this.changeVendorInput;
    if (changeVendorInput) {
      const results = queryString
        ? vendorLinks.filter(this.createFilter(queryString))
        : vendorLinks;
      cb(results);
    } else {
      cb(vendorLinks);
    }
  }

  vendorHandleSelect(item: any) {
    this.ruleForm.fkVendorId = item.id;
    this.ruleForm.vendorName = item.name;
    this.vendorName = item.name;
    this.changeVendorInput = false;
  }

  vendorHandleInput() {
    this.changeVendorInput = true;
  }

  vendorHandleChange(queryString: any) {
    if (queryString) {
      const vendorLinks = this.c_getterVendors;
      const groupId: string = this.$route.params.groupId;
      const isNotValid = vendorLinks.filter((link: any) => link.name.includes(queryString)).length;
      if (!isNotValid) {
        this.$confirm(
          'LAB 관리 > 판매처에서 모든 판매처 목록을 관리하실 수 있습니다.',
          `'${queryString}' 판매처를 추가하시겠습니까?`,
          {
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            type: 'warning',
          }
        )
          .then(async () => {
            try {
              const item = await this.c_setVendor({
                groupId,
                payload: {
                  name: queryString,
                },
              });
              this.ruleForm.fkVendorId = item.id;
              await this.c_getVendors(groupId);
              this.openSuggestions('vendorName');
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e) => {
            this.vendorName = '';
            this.ruleForm.fkVendorId = null;
            console.log(e);
          });
      }
    }
  }

  manufacturerQuerySearch(queryString: string, cb: any) {
    const manufacturerLinks = this.c_getterManufacturers;
    const changeManufacturerInput = this.changeManufacturerInput;
    if (changeManufacturerInput) {
      const results = queryString
        ? manufacturerLinks.filter(this.createFilter(queryString))
        : manufacturerLinks;
      cb(results);
    } else {
      cb(manufacturerLinks);
    }
  }

  manufacturerHandleSelect(item: any) {
    this.ruleForm.fkManufacturerId = item.id;
    this.ruleForm.manufacturerName = item.name;
    this.manufacturerName = item.name;
    this.changeManufacturerInput = false;
  }

  manufacturerHandleInput() {
    this.changeManufacturerInput = true;
  }

  @Watch('manufacturerName')
  onManufacturerName(c: any, p: any) {
    if (this.manufacturerName === '') {
      this.ruleForm.fkManufacturerId = null;
      this.ruleForm.manufacturerName = null;
    }
  }

  manufacturerHandleChange(queryString: any) {
    if (queryString) {
      const manufacturerLinks = this.c_getterManufacturers;
      const groupId: string = this.$route.params.groupId;
      const isNotValid = manufacturerLinks.filter((link: any) => link.name.includes(queryString))
        .length;
      if (!isNotValid) {
        this.$confirm(
          'LAB 관리 > 제조사에서 모든 제조사 목록을 관리하실 수 있습니다.',
          `'${queryString}' 제조사를 추가하시겠습니까?`,
          {
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            type: 'warning',
          }
        )
          .then(async () => {
            try {
              const item = await this.c_setManufacturer({
                groupId,
                payload: {
                  name: queryString,
                },
              });
              this.ruleForm.fkManufacturerId = item.id;
              await this.c_getManufacturers(groupId);
              this.openSuggestions('manufacturerName');
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e) => {
            this.manufacturerName = '';
            this.ruleForm.fkManufacturerId = null;
            console.log(e);
          });
      }
    }
  }

  typeQuerySearch(queryString: string, cb: any) {
    const typeLinks = this.c_getterTypes;
    const changeTypeInput = this.changeTypeInput;
    if (changeTypeInput) {
      const results = queryString ? typeLinks.filter(this.createFilter(queryString)) : typeLinks;
      cb(results);
    } else {
      cb(typeLinks);
    }
  }

  async typeHandleSelect(item: any) {
    const groupId: string = this.$route.params.groupId;

    this.ruleForm.typeName = item.name;
    this.typeName = this.ruleForm.typeName;
    this.ruleForm.fkTypeId = item.id;
    this.changeTypeInput = false;

    await this.c_getTypeFields({ groupId, typeId: item.id });
    this.customTypeArray = this.c_getterTypeFields;
    this.ruleForm.customFields = [...this.customTypeArray];
  }

  typeHandleInput() {
    this.changeTypeInput = true;
  }

  typeHandleChange(queryString: any) {
    if (queryString) {
      const typeLinks = this.c_getterTypes;
      const groupId: string = this.$route.params.groupId;
      const val = typeLinks.filter((link: any) => link.name.includes(queryString)).length;
      if (!val) {
        this.$confirm(
          'LAB 관리 > 타입 에서 모든 타입 목록을 관리하실 수 있습니다.',
          `'${queryString}' 타입을 추가하시겠습니까?`,
          {
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            type: 'warning',
          }
        )
          .then(async () => {
            try {
              const item = await this.c_setType({
                groupId,
                payload: {
                  name: queryString,
                },
              });
              this.ruleForm.fkTypeId = item.id;
              await this.c_getTypes(groupId);
              this.customTypeArray = [];
              this.ruleForm.customFields = [...this.customTypeArray];
              this.openSuggestions('typeName');
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e) => {
            this.ruleForm.typeName = this.typeName;
            console.log(e);
          });
      }
    }
  }

  mainLocationQuerySearch(queryString: string, cb: any) {
    const links = this.c_getterMainLocations;

    const changeMainLocationInput = this.changeMainLocationInput;
    if (changeMainLocationInput) {
      const results = queryString ? links.filter(this.createFilter(queryString)) : links;
      cb(results);
    } else {
      cb(links);
    }
  }

  mainLocationFocus() {
    if (this.mainLocationName === '') {
      this.subLocationName = '';
    }
  }

  @Watch('mainLocationName')
  onMainLocationName(c: any, p: any) {
    if (this.mainLocationName === '') {
      this.ruleForm.fkLocationId = null;
      this.subLocationName = '';
      this.ruleForm.fkLocationSubId = null;
    }
  }

  async mainLocationHandleSelect(item: any) {
    const groupId: string = this.$route.params.groupId;
    const locationId: string = item.id;

    this.mainLocationName = item.name;
    this.subLocationName = '';
    this.ruleForm.fkLocationId = locationId;
    this.changeMainLocationInput = false;
    await this.c_getSubLocations({ groupId, locationId });
    this.subLocationArray = this.c_getterSubLocations;
  }

  mainLocationHandleInput() {
    this.changeMainLocationInput = true;
  }

  @Watch('mainLocationName')
  onSubLocationName(c: any, p: any) {
    if (this.subLocationName === '') {
      this.ruleForm.fkLocationSubId = null;
    }
  }

  mainLocationHandleChange(queryString: any) {
    if (queryString) {
      const links = this.c_getterMainLocations;
      const groupId: string = this.$route.params.groupId;
      const isNotValid = links.filter((link: any) => link.name.includes(queryString)).length;

      if (!isNotValid) {
        this.$confirm(
          'LAB 관리 > 보관위치 에서 모든 보관위치 목록을 관리하실 수 있습니다.',
          `'${queryString}' 보관위치를 추가하시겠습니까?`,
          {
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            type: 'warning',
          }
        )
          .then(async () => {
            try {
              const item = await this.c_setMainLocation({
                groupId,
                payload: {
                  name: queryString,
                },
              });
              this.ruleForm.fkLocationId = item.id;
              this.subLocationName = '';
              await this.c_getMainLocations(groupId);
              this.subLocationArray = [];
              this.openSuggestions('location');
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e: Error) => {
            this.mainLocationName = '';
            this.ruleForm.fkLocationId = null;
            console.log(e);
          });
      }
    }
  }

  subLocationQuerySearch(queryString: string, cb: any) {
    const links = this.subLocationArray;
    const changeSubLocationInput = this.changeSubLocationInput;
    if (changeSubLocationInput) {
      const results = queryString ? links.filter(this.createFilter(queryString)) : links;
      cb(results);
    } else {
      cb(links);
    }
  }

  subLocationHandleSelect(item: any) {
    this.subLocationName = item.name;
    this.ruleForm.fkLocationSubId = item.id;
    this.changeSubLocationInput = false;
  }

  subLocationHandleInput() {
    this.changeSubLocationInput = true;
  }

  subLocationHandleChange(queryString: any) {
    if (queryString) {
      const links = this.subLocationArray;
      const groupId: string = this.$route.params.groupId;
      const val = links.filter((link: any) => link.name.includes(queryString)).length;

      if (!val) {
        this.$confirm(
          'LAB 관리 > 보관위치 에서 모든 보관위치 목록을 관리하실 수 있습니다.',
          `'${queryString}' 세부위치를 추가하시겠습니까?`,
          {
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            type: 'warning',
          }
        )
          .then(async () => {
            try {
              const item = await this.c_setSubLocation({
                groupId,
                locationId: this.ruleForm.fkLocationId,
                payload: {
                  name: queryString,
                },
              });
              this.ruleForm.fkLocationSubId = item.id;
              await this.c_getSubLocations({ groupId, locationId: this.ruleForm.fkLocationId });
              this.subLocationArray = this.c_getterSubLocations;
              openSuggestions('subLocation');
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e) => {
            this.subLocationName = '';
            this.ruleForm.fkLocationSubId = null;
            console.log(e);
          });
      }
    }
  }

  ownedItem(...arg: Array<string>) {
    this.initOwner = arg[0];
    this.ruleForm.ownedBy = arg[1];
  }

  ownedSelect(f: any) {
    const stringArray: any = f.split('_');
    const self: any = this;
    self[stringArray[0]](stringArray[1], stringArray[2]);
  }

  attachFile(): void {
    (this.$refs.file as HTMLInputElement).click();
  }

  addFile(e: any): void {
    for (let i = 0; i < e.target.files.length; i++) {
      const file = e.target.files[i];
      this.fileNameArray.push(file.name);
      this.filePayload.push(file);
    }
  }

  deleteFile(fileName: string): void {
    this.fileNameArray.splice(this.fileNameArray.indexOf(fileName), 1);
    this.filePayload.splice(this.filePayload.indexOf(fileName), 1);
  }

  customFieldToggle(): void {
    if (this.isShow) {
      this.isShow = false;
      this.staticCustomFieldString = '타입 세부정보 추가하기';
    } else {
      this.isShow = true;
      this.staticCustomFieldString = '타입 세부정보 숨기기';
    }
  }

  async submitInventory() {
    const groupId: string = this.$route.params.groupId;
    (this.$refs.ruleForm as HTMLFormElement).validate(async (valid: boolean) => {
      if (valid) {
        try {
          await this.c_setInventoryItem({
            groupId,
            payload: this.ruleForm,
            files: this.filePayload,
          });
          this.propsDialogVisible = false;
          this.$emit('emitModalItemClose', {
            isVisible: this.propsDialogVisible,
            isUpload: true,
          });
        } catch (e) {
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      } else {
        this.$message.error('물품 추가를 실패하였습니다.');
        return false;
      }
    });
  }

  @Emit('emitModalItemClose')
  handleClose(destination: string | undefined) {
    this.propsDialogVisible = false;
    return {
      isVisible: this.propsDialogVisible,
      isUpload: false,
    };
  }
}
